export const getRovoChatProduct = (): string => {
	let product = 'UNKNOWN';
	if (window && (window as any).__ROVO_CHAT_CONFIG_PRODUCT__) {
		product = (window as any).__ROVO_CHAT_CONFIG_PRODUCT__;
	}
	return product;
};
